import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import i18n from './helpers/i18n';
import configureStore from './store/configureStore';
import App from './App';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { MuiThemeProvider, createGenerateClassName } from '@material-ui/core/styles';
import composerTheme from './helpers/composerTheme';
import urls from 'composer-blocks/lib/constants/urls';
import JssProvider from 'react-jss/lib/JssProvider';
import * as Sentry from '@sentry/react';

Sentry.init({
  environment: process.env.NODE_ENV,
  dsn: "https://dd01e506533de3720e4a4b2e43f86903@o193591.ingest.us.sentry.io/4510778560282624",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  // sendDefaultPii: false,
  // integrations: [new Integrations.BrowserTracing()],
  // tracesSampleRate: 1.0,
});

const generateClassName = createGenerateClassName({
  productionPrefix: 'cmpsr',
});
urls.setEventtiaBase(process.env.REACT_APP_BASE_URL);
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <JssProvider generateClassName={generateClassName}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <MuiThemeProvider theme={composerTheme}>
            <div>
              <Switch>
                <Route path="/:locale(en|es|fr|it|pt-BR|pt|de|ca|nl|ar|vi|zh|zh-TW|ko|ja)" component={App}/>
                <Route render={({ location }) => <Redirect to={`/en${location.pathname}${location.search}${location.hash}`}/>}/>
              </Switch>
            </div>
          </MuiThemeProvider>
        </BrowserRouter>
      </I18nextProvider>
    </JssProvider>
  </Provider>,
  document.getElementById('root')
);
